module.exports = __webpack_public_path__ + "static/img/2017.204509d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/newEvents/2017.png
// module id = WkRu
// module chunks = 1